module.exports = require('./lib/immutable')



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/immutable.js
 ** module id = 472
 ** module chunks = 1
 **/